<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="do-not-print">
    <div class="row">
        <div class="col-24">
            <h1>My Clients</h1>
        </div>
    </div>
    <div class="row" *ngIf="false">
        <div class="col-24">
            <button id="btnTempIDCard" class="button primary" (click)="onGetTemporaryIDCard()">Temporary Member ID Card</button>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            Data current as of: {{this.wesLastAccessDate}}
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button id="btnBack" class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>
    <div class="row">
        <div class="col-2">
            <a id="btnPrint" class="link-button link print" (click)="onPrint()">Print</a>
        </div>
        <div class="col-8">
            <div class="bottom-10">
                <button id="btnExport" class="button link excel" (click)="onExport()">Export to Excel (downloads in a new window)</button>
            </div>
        </div>
    </div>
</div>
<div id="printArea">
    <div class="row">
        <div class="col-24">
            <div class="jqgrid-header-wrap">
                <jqxGrid [width]="width"
                         [virtualmode]="true"
                         [rendergridrows]="rendergridrows"
                         [source]="dataAdapter"
                         [columns]="columns"
                         [autorowheight]="true"
                         [autoshowcolumnsmenubutton]="false"
                         [autoheight]="true"
                         [pageable]="true"
                         [pagesizeoptions]="[20, 50, 100]"
                         [pagesize]="50"
                         [sortable]="true"
                         [filterable]="true"
                         [updatefilterconditions]="updatefilterconditions"
                         [columnsresize]="true"
                         [ready]="ready"
                         [selectionmode]="'multiplecellsadvanced'"
                         (onSort)="onSort($event)"
                         (onFilter)="onFilter($event)"
                         (onPagesizechanged)="onPageSizeChanged($event)"
                         (onCellclick)="Cellclick($event)"
                         (onRowclick)="OnRowClick($event)"
                         #TreeGrid>
                </jqxGrid>
            </div>
        </div>
    </div>
</div>
<copyto-clipboard [grid]="gridObj" [event]="eventObj"></copyto-clipboard>